<template>
  <div class="videoContainer">
    <div class="overlay" />
    <video
      class="bg-login"
      loop
      autoplay
      muted
    >
      <source
        src="https://static.educacionit.com/alumni/assets/bg-login.webm"
        type="video/webm"
      >
    </video>
    <login-form v-if="showForm" />
  </div>
</template>

<script>
import LoginForm from '@/modules/LoginForm';

export default {
  name: 'LoginView',
  components: {
    LoginForm,
  },
  computed: {
    error() {
      return this.$store.state.services.api.api.error;
    },
    showForm() {
      return this.error !== 'NO_CONNECTION';
    },
  },
};
</script>

<style lang="postcss" scoped>
.bg-login {
  position: fixed;
  top: 0;
}
.videoContainer {
  position: relative;
  height: 100vh;
  background-attachment: scroll;
  overflow: hidden;
  & video {
    min-width: 100%;
    min-height: 100%;
    position: relative;
    z-index: 1;
  }
  & .overlay {
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    background: #000;
    opacity: 0.8;
  }
}
</style>
